import { render, staticRenderFns } from "./ApplicationStatusHistory.vue?vue&type=template&id=5646e9bf&scoped=true&"
import script from "./ApplicationStatusHistory.vue?vue&type=script&lang=js&"
export * from "./ApplicationStatusHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646e9bf",
  null
  
)

export default component.exports